import React, { useState, useCallback } from "react"
import { useTranslation } from "react-i18next"
import debounce from "lodash.debounce"
import SearchIcon from "@material-ui/icons/Search"

const TgSearch = ({ placeholder = "Buscar", value, onChange }) => {
  const { t: tGlobal } = useTranslation("global")
  const [inputValue, setInputValue] = useState(value)
  const [hover, setHover] = useState(false)

  // Memorizar la función debounced (solo para filtrar los datos)
  const debouncedOnChange = useCallback(debounce(onChange, 500), [onChange])

  const handleChange = e => {
    setInputValue(e.target.value) // Muestra el texto inmediatamente
    debouncedOnChange(e.target.value) // Filtra los datos con retraso
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: `1px solid ${hover ? "#092147" : "#ccc"}`,
        borderRadius: "8px",
        padding: "8px",
        transition: "all 0.3s ease-in-out",
        boxShadow: hover ? "0px 4px 10px rgba(0, 123, 255, 0.2)" : "none",
        outline: "none",
        width: "100%",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <input
        type="text"
        placeholder={tGlobal("search") || placeholder}
        value={inputValue} // Muestra el texto en tiempo real
        onChange={handleChange} // Usa la función optimizada
        style={{
          border: "none",
          outline: "none",
          flex: 1,
          fontSize: "16px",
        }}
      />
      <SearchIcon
        style={{
          color: hover ? "#092147" : "#ccc",
          transition: "color 0.3s ease-in-out",
        }}
      />
    </div>
  )
}

export default TgSearch
